export default __webpack_public_path__ + "static/media/go.7cc7fe18.png";